import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/interactiveMap.jpg'
import _imports_1 from '../assets/interactiveMapRetina.jpg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-b54471c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + ' 1x, ' + _imports_1 + ' 2x'
const _hoisted_2 = { class: "interactiveMapBanner" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "dashedBorder" }
const _hoisted_6 = { class: "preamble" }
const _hoisted_7 = { class: "image" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  srcset: _hoisted_1,
  loading: "lazy",
  alt: ""
}, null, -1))

import { Button, IconText } from '@components';


export default /*#__PURE__*/_defineComponent({
  __name: 'InteractiveMapLanding',
  props: {
    title: {},
    text: {}
  },
  emits: ['setExploreBtnClicked'],
  setup(__props: any) {






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.text), 1),
        _createVNode(_unref(Button), {
          label: _ctx.$t('Explore map'),
          "on-click": () => _ctx.$emit('setExploreBtnClicked', true)
        }, null, 8, ["label", "on-click"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_unref(Button), {
          class: "mobileExploreBtn",
          label: "",
          "on-click": () => _ctx.$emit('setExploreBtnClicked', true)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IconText), {
              "icon-name": "mapIconBlack",
              text: _ctx.$t('Explore map')
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["on-click"])
      ])
    ])
  ]))
}
}

})